import React from "react";
import LogoLoop, { LogoItem } from "../LogoLoop/LogoLoop";
import "./MovingTextLoop.css";

const textItems: LogoItem[] = [
  { node: <span className="moving-text">Liberty</span> },
  { node: <span className="moving-text">Justice</span> },
  { node: <span className="moving-text">Advocate</span> },
];

export default function MovingTextLoop() {
  return (
    <div style={{ width: "100%", marginTop: "20px" }}>
      <LogoLoop
        logos={textItems}
        speed={100}
        gap={60}
        logoHeight={30}
        fadeOut={false}
        scaleOnHover={false}
        direction="left"
        ariaLabel="Moving Text Banner"
      />
    </div>
  );
}
